import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcAutocompleteItem]'
})
export class AutocompleteItemDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
